import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Paper,
  Typography,
  TextField,
  Button,
  Box,
  Alert,
  CircularProgress,
  Divider
} from '@mui/material';
import axios from 'axios';

// ⚠️ OBSOLETO (confirmado por Agustín, 2026-07-30). La ruta /unique-payment no se usa:
// el cobro real va por suscripción en /subscribe. El monto de abajo quedó en $120.000,
// de una estructura de precios vieja (hoy son $150.000 equipo / $300.000 Agustín), así
// que NO enlazar esta página desde ningún lado sin actualizarla antes.
// Se deja montada por si algún link antiguo sigue circulando.

const FIXED_AMOUNT = 120000;
const CURRENCY = 'CLP';
const SUBJECT = 'Mensualidad AU Coaching Services';

const PaymentPage = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    email: ''
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      const API_URL = process.env.REACT_APP_API_URL;
      const response = await axios.post(`${API_URL}/api/unique/payment`, {
        amount: FIXED_AMOUNT,
        name: formData.name,
        email: formData.email
      });

      setSuccess('Pago procesado exitosamente');
      console.log('Respuesta del servidor:', response.data);
      navigate('/success-request', { state: { email: formData.email, paymentOrSubscription: 'pago' } });
    } catch (err) {
      setError(err.response?.data?.message || 'Error al procesar el pago. Por favor, intente nuevamente.');
      console.error('Error:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 4, mb: 4 }}>
        <Paper elevation={3} sx={{ p: 4 }}>
          <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
            <img src="/logo.jpg" alt="Logo" style={{ maxWidth: 160, maxHeight: 80 }} />
          </Box>
          <Typography variant="h4" component="h1" gutterBottom align="center">
            Realizar Pago Único {SUBJECT}
          </Typography>

          <Box sx={{ 
            bgcolor: 'primary.main', 
            color: 'white', 
            p: 2, 
            borderRadius: 1,
            mb: 3,
            textAlign: 'center'
          }}>
            <Typography variant="h5" component="div">
              Monto a Pagar
            </Typography>
            <Typography variant="h4" component="div" sx={{ fontWeight: 'bold' }}>
              {`$${FIXED_AMOUNT.toLocaleString('es-CL')} ${CURRENCY}`}
            </Typography>
          </Box>

          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}

          {success && (
            <Alert severity="success" sx={{ mb: 2 }}>
              {success}
            </Alert>
          )}

          <form onSubmit={handleSubmit}>
            <TextField
              fullWidth
              label="Nombre completo"
              name="name"
              value={formData.name}
              onChange={handleChange}
              margin="normal"
              required
            />

            <TextField
              fullWidth
              label="Email"
              name="email"
              type="email"
              value={formData.email}
              onChange={handleChange}
              margin="normal"
              required
            />

            <TextField
              fullWidth
              label="Monto"
              name="amount"
              value={`$${FIXED_AMOUNT.toLocaleString('es-CL')} CLP`}
              InputProps={{ readOnly: true }}
              margin="normal"
            />

            <Divider sx={{ my: 3 }} />

            <Box sx={{ textAlign: 'center', mb: 2 }}>
              <Typography variant="body1" color="text.secondary">
                Al realizar el pago, aceptas el cargo de ${FIXED_AMOUNT.toLocaleString('es-CL')} CLP
              </Typography>
            </Box>

            <Button
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              size="large"
              disabled={loading}
              sx={{ mt: 2 }}
            >
              {loading ? <CircularProgress size={24} /> : 'Pagar ahora'}
            </Button>
          </form>
        </Paper>
      </Box>
    </Container>
  );
};

export default PaymentPage; 